/** O que entra na conta do mês, já somado (centavos). */
export type BaseDoMes = {
  /** Serviços concluídos e retrabalhos cobrados no mês (regime de competência). */
  faturamentoCents: number;
  /** Entradas lançadas à mão que não são recebimento de extrato. */
  outrasReceitasCents: number;
  /** Material consumido na produção do mês (custo congelado da ficha). */
  custoProducaoCents: number;
  /** Saídas variáveis lançadas (impostos, frete...), fora as compras de estoque. */
  despesasVariaveisCents: number;
  custosFixosCents: number;
};

export type ResumoDoMes = BaseDoMes & {
  receitaCents: number;
  custoVariavelCents: number;
  margemCents: number;
  /** Margem de contribuição sobre a receita (0 a 1); nulo sem receita. */
  margemPct: number | null;
  resultadoCents: number;
  /** Receita que paga os custos fixos com a margem atual; nulo sem margem positiva. */
  pontoDeEquilibrioCents: number | null;
  faltaParaEquilibrioCents: number | null;
};

/**
 * Receita − custo variável = margem de contribuição; − custos fixos = resultado. A compra de
 * estoque não entra aqui (é caixa); o custo do material entra quando ele é consumido.
 */
export function resumoDoMes(b: BaseDoMes): ResumoDoMes {
  const receitaCents = b.faturamentoCents + b.outrasReceitasCents;
  const custoVariavelCents = b.custoProducaoCents + b.despesasVariaveisCents;
  const margemCents = receitaCents - custoVariavelCents;
  const margemPct = receitaCents > 0 ? margemCents / receitaCents : null;
  const pontoDeEquilibrioCents = margemPct && margemPct > 0 ? Math.ceil(b.custosFixosCents / margemPct) : null;
  return {
    ...b,
    receitaCents,
    custoVariavelCents,
    margemCents,
    margemPct,
    resultadoCents: margemCents - b.custosFixosCents,
    pontoDeEquilibrioCents,
    faltaParaEquilibrioCents: pontoDeEquilibrioCents == null ? null : Math.max(0, pontoDeEquilibrioCents - receitaCents),
  };
}

/** Variação relativa contra o mês anterior; nulo quando não há base para comparar. */
export function variacao(atual: number, anterior: number): number | null {
  if (!anterior) return null;
  return (atual - anterior) / Math.abs(anterior);
}

/** Custo de uma linha de consumo, na mesma regra da produção: indireta e sem preço não contam. */
export function custoDoConsumo(c: { materialLineId: string | null; indirect: boolean; unitCostCents: number | null; quantityNet: number; correctionFactor: number }): number {
  if (!c.materialLineId || c.indirect || c.unitCostCents == null) return 0;
  return c.quantityNet * (c.correctionFactor || 1) * c.unitCostCents;
}
